export const UPDATE_ONBOARDING_STEP = 'artful-client/Onboarding/UPDATE_ONBOARDING_STEP';
export const SET_STREAMS_READY = 'artful-client/Onboarding/SET_STREAMS_READY';
